import styled from "styled-components"
import { color } from "../../../atoms/colors"
import { font } from "../../../atoms/typography"

export const ROIHeroWrap = styled.section`
  font-family: Roboto, sans-serif;
  margin-top: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 500px;
  align-items: center;
  overflow: hidden;
  background-color: ${color.grey[100]};
  padding: 0 30px;
`

export const ImageWrap = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
  height: 800px;
  overflow: hidden;
`

export const ROIHeroImage = styled.img`
  position: relative;
  min-width: 100%;
  min-height: 800px;
`

export const BreadcrumbContainer = styled.div`
  display: flex;
  margin: 0 auto;
  width: 100%;
  align-items: center;
  padding: 25px 0 0;
  max-width: 506px;
  @media (min-width: 577px) {
    max-width: 770px;
  }
  @media (min-width: 993px) {
    max-width: 1170px;
  }
`

export const TextContent = styled.div`
  display: grid;
  row-gap: 16px;
  max-width: 770px;
  margin: 0 auto;
  color: ${color.common.white};
  text-align: center;
  margin: 64px 0 40px;
  z-index: 1;
  @media (min-width: 577px) {
    margin: 64px 0 56px;
  }
  @media (min-width: 993px) {
    margin: 80px 0 64px;
  }
`

export const Eyebrow = styled.span`
  ${font('kicker', 'reg', '900')}
  color: #69D1F0;
`

export const Heading = styled.h1`
  ${font('display', 'sm', '700')}
  text-align: center;
  color: ${color.common.white};
  @media (min-width: 577px) {
    ${font('display', 'md', '700')}
  }
  @media (min-width: 993px) {
    ${font('display', 'lg', '900')}
  }
`

export const Subhead = styled.p`
  margin-bottom: 0;
  ${font('text', 'reg', '400')}
  text-align: center;
  color: ${color.grey[200]};
  @media (min-width: 577px) {
    ${font('text', 'lg', '400')}
  }
`
